module.exports = __webpack_public_path__ + "static/media/Blik.e9fcbfe9.svg";